import { render } from "./EditDeviceModal.vue?vue&type=template&id=b8f20c22&scoped=true"
import script from "./EditDeviceModal.vue?vue&type=script&lang=js"
export * from "./EditDeviceModal.vue?vue&type=script&lang=js"

import "./EditDeviceModal.vue?vue&type=style&index=0&id=b8f20c22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8f20c22"]])

export default __exports__